"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const DownloadCircle = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: "33",
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("rect", {
  x: "1",
  width: 32,
  height: 32,
  rx: "16",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.9969 19C16.7305 18.9992 16.4644 18.8981 16.2612 18.6967L13.306 15.7678C12.898 15.3634 12.898 14.7077 13.306 14.3033C13.714 13.8989 14.3756 13.8989 14.7836 14.3033L16 15.5089V9C16 8.44772 16.4477 8 17 8C17.5523 8 18 8.44771 18 9V15.5089L19.2164 14.3033C19.6244 13.8989 20.286 13.8989 20.694 14.3033C21.102 14.7077 21.102 15.3634 20.694 15.7678L17.7388 18.6967C17.5356 18.8981 17.2695 18.9992 17.0031 19C17.0021 19 17.001 19 17 19C16.999 19 16.9979 19 16.9969 19ZM10 18C10.5523 18 11 18.4477 11 19V21C11 21.5523 11.4477 22 12 22H22C22.5523 22 23 21.5523 23 21V19C23 18.4477 23.4477 18 24 18C24.5523 18 25 18.4477 25 19V21C25 22.6569 23.6569 24 22 24H12C10.3431 24 9 22.6569 9 21V19C9 18.4477 9.44772 18 10 18Z",
  fill: "white"
}));
var _default = exports.default = DownloadCircle;